import { Reveal } from "../motion/Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";
import { faqs } from "../../data/academyData";

export const FAQSection = () => (
  <section id="faq" data-testid="faq-section" className="relative py-20 md:py-32 bg-[#0A0A0D] border-t border-white/[0.06]">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4 text-center">FAQ</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white text-center leading-tight">Frequently Asked Questions</h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="rounded-xl bg-white/[0.03] border border-white/10 px-5">
              <AccordionTrigger data-testid={`faq-accordion-trigger-${i + 1}`} className="text-white text-left text-base sm:text-lg font-medium hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
